module.exports = new __parcel__URL__("nuage-3.c44add4c.svg").toString();